import { registerPlugin } from '@capacitor/core';
const NuanceSpeechkit = registerPlugin('NuanceSpeechkit', {
    web: () => import('./web').then(m => new m.NuanceSpeechkitWeb()),
});
export * from './definitions';
export { NuanceSpeechkit };
//# sourceMappingURL=index.js.map